<template>
    <div id="dashboard" class="pb-5">
        <Loading v-if="isLoading" />

        <dashboard-menu
			@updateCategories="populateCategories"
            @updateActiveCategory="updateActiveCategory"
			ref="menu"
			:route="activeCategoryRoute"
			@avatar="userAvatar = $event"
		/>

		<alert-message
			v-if="alertMessageData.show"
			@alertToggle="hideAlertMessage"
		>
			<p slot="title" class="title-alert">{{ alertMessageData.title }}</p>
			<p slot="text" class="text-alert">{{ alertMessageData.message }}</p>
		</alert-message>

		<alert-bar v-if="showAlertBar" />

        <div class="container">
			<div class="row justify-content-md-center align-items-center">
				<div class="col-12 categories text-center">
					<b-tabs v-model="tabIndex">
						<b-tab :key="'search'" @click="handleSearch">
							<template slot="title">
								<i class="fas fa-search"></i>
							</template>

							<search />
						</b-tab>

                        <!-- TAB HOME -->
						<b-tab active :key="'home'" @click="handleHome">
							<template slot="title">
								<span class="news--class" style="margin-top: -10px;">
                                    <i class="fas fa-home"></i>
                                </span>
							</template>

                            <!-- Bunner Trial -->
							<div class="row" v-if="true">
								<div class="col-12">
									<report
                                        v-if="report"
                                        :daysReport="daysReport"
                                        @days="daysReport = $event"
									/>
								</div>
							</div>

                            <!-- Comment Card -->
							<div class="d-flex flex-nowrap box pr-4">
								<div
									class="comment-card"
									v-for="(comment,index) in getComments"
									:key="comment.id"
								>
									<comment-card-home
										:indexComments="index"
										:dataContent="comment"
										:siteId="siteId"
										:siteName="siteName"
										:siteAvatar="userAvatar"
                                    />
								</div>

								<div  v-if="loadingNextComments" class="next-comments">
									<i class="fal fa-spinner fa-spin fa-2x mt-3"></i>
								</div>

								<button v-if="nextCommentsUrl && !loadingNextComments" @click="populateComments" class="btn btn-primario next-comments">
									<i class="fas fa-plus"></i>
								</button>
							</div>

                            <!-- Suggestions Posts -->
							<div v-show="checkImporteds > 0" class="suggestions">
								<span v-if="checkImporteds == 1">
                                    <strong> {{ checkImporteds }} nova sugestão de post gerada. </strong>
                                    Escolha publicar, editar ou agendar.
                                </span>

								<span v-else>
                                    <strong> {{ checkImporteds }} novas sugestões de posts geradas.</strong>
                                    Escolha qual publicar, editar ou agendar.
                                </span>
							</div>

                            <!-- Posts -->
							<masonry
                                :cols="{ default: 3, 1000: 2, 700: 1 }"
                                :gutter="{default: '25px', 700: '15px'}"
                            >
								<div
									class="post-content"
									v-if="checkTrial"
								>
									<alert-card />
								</div>

								<div
									class=" post-content"
									v-else-if="checkCodes"
								>
									<card-message-uli />
								</div>

								<div
									class="post-content"
									v-for="post in posts"
									:key="post.id"
								>
									<card-template
										:dataContent="post"
										@deleteCard="loadPosts"
									></card-template>
								</div>
							</masonry>

                            <!-- No Posts -->
							<div
								class="row pb-5"
								v-show="
									hasNews === 0 &&
									getStart == false &&
									busy == false &&
									checkTrial == false
								"
							>
								<div class="col-12 text-center">
									<img src="@/assets/img/unicorn.png" alt />

									<h4>Sem posts novos</h4>

									<p>
										Novos conteúdos serão exibidos aqui
										<br />
                                        quando importados de suas redes
									</p>

									<p>
										<a href="#" @click="createPost()">
											<strong>Ou crie um novo</strong>
										</a>
									</p>
								</div>
							</div>

                            <!-- Loading -->
							<div
								class="row pb-5"
								v-show="
									hasNews === 0 &&
									getStart == false &&
									busy == true
								"
							>
                                <spinner-grow-loading />
							</div>
						</b-tab>

                        <!-- TABS OF MENUS -->
                        <b-tab
							v-for="category in categories"
							:key="category.id"
							:data-subpage="category.id"
							@click="
								onChange(
									category.listPages,
									category.id,
									category.type,
									category.route
								)
							"
						>
							<template slot="title">
								<span :data-id="category.id" style="white-space: nowrap;">
                                    {{ normalizeName(category.name) }}
                                </span>
							</template>

							<div class="col-4 ml-auto mb-3">
								<div class="op-post" id>
									<div class="row">
                                        <!--
                                            <change-order-posts
                                                id="inputGroupSelect01"
                                                @updateSortType="updateSortType($event, category.id)"
                                            />
                                        -->
										<select
											v-model="sortType"
											@change="updateOrder(category.id)"
											class="select pr-1 bg-transparent form-control"
											id="inputGroupSelect01"
										>
											<option value="CHRONODESC">
												Mais Novas
											</option>
											<option value="CHRONOASC">
												Mais Antigas
											</option>
											<option value="ALPHABASC">
												Ordem Alfabetica A-Z
											</option>
											<option value="ALPHABDESC">
												Ordem Alfabetica Z-A
											</option>
											<option value="CUSTOM">
												Personalizada(arraste)
											</option>
										</select>
									</div>
								</div>
							</div>

							<div class="row" v-if="busy == true">
								<spinner-grow-loading />
							</div>

							<div
								v-else-if="
									busy === false
								"
							>
								<div v-if="sortType === 'CUSTOM'">
									<draggable
										class="row"
										v-model="posts"
										@start="drag = true"
										@end="drag = false"
										@change="updateOrder(category.id)"
                                        :force-fallback="true"
									>
										<div
											class="col-12 col-md-6 col-lg-4 mb-4 post-content"
											v-for="post in showingPosts"
											:key="post.postId"
                                            :id="post.postId"
										>
											<card-template
												:dataContent="post"
												@alertToggle="toggleAlertMessage"
												@deleteCard="loadPosts"
											></card-template>
										</div>
									</draggable>
								</div>

								<masonry
									v-else
									:cols="{ default: 3, 1000: 2, 700: 1 }"
									:gutter="{default: '25px', 700: '15px'}"
                                >
									<div
										class="post-content"
										v-for="post in posts"
										:key="post.postId"
                                        :id="post.postId"
									>
										<card-template
											:dataContent="post"
											@alertToggle="toggleAlertMessage"
                                            @deleteCard="loadPosts"
										></card-template>
									</div>
								</masonry>
							</div>

							<div class="row" v-else>
								<div class="col-12 text-center pt-4">
									<h4>Não há publicações nessa sessão</h4>
									<p>
										<a class="cursor-pointer"
											@click.prevent="createPost()">
											<strong>Criar publicação</strong>
										</a>
									</p>
								</div>
							</div>
						</b-tab>
					</b-tabs>
				</div>
			</div>

            <new-section
                @toggleCreatePageOrSectionLoading="loadingScreen = $event"
                v-if="addSessionModal"
                :sectionsCategories="categories"
                @returnAddSessionModal="addSessionModal = $event"
                @newCategories="categories = $event"
                :showAllOptions="true"
            />

			<button-create-post v-if="isBlog" :pageId="activeCategory" @createPost="createPost" />
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";

import DashboardMenu from "@/components/DashboardMenu";
import AlertMessage from "@/components/organisms/AlertMessage";
import AlertBar from "@/components/molecules/AlertBar";
import Search from "@/components/Search";
import CardTemplate from "@/components/CardTemplate";
import AlertCard from "@/components/molecules/AlertCard";
import CardMessageUli from "@/components/molecules/CardMessageUli";
import NewSection from "@/components/organisms/NewSection";
import ButtonCreatePost from "@/components/molecules/ButtonCreatePost";
import Report from "@/components/organisms/Report";
import CommentCardHome from "@/components/molecules/CommentCardHome";
import SpinnerGrowLoading from "@/components/molecules/SpinnerGrowLoading";
import ChangeOrderPosts from "@/components/molecules/ChangeOrderPosts";
import Loading from "../Loading.vue";

import apiMixins from "@/mixins/apiMixins";
import sectionsMixins from "@/mixins/sectionsMixins";
import moment from "moment";

export default {
    name: 'DashboardHome',
    components: {
        Loading,
        DashboardMenu,
        AlertMessage,
        AlertBar,
        Search,
        CardTemplate,
        AlertCard,
        CardMessageUli,
        NewSection,
        ButtonCreatePost,
        Report,
        CommentCardHome,
        draggable,
        SpinnerGrowLoading,
        ChangeOrderPosts
    },
    data() {
        return {
            isBlog: false,
            isLoading: false,
            postId: this.postId,
            addSessionModal: false,
            daysReport: 30,
            report: true,
            alertMessageData: {
                show: false,
                title: "",
                message: "",
            },
            getStart: true,
            user_name: this.$session.get("userName"),
            siteId: null,
            categories: [],
            activeCategory: null,
            activeCategoryRoute: null,
            selectedCategory: "news",
            searchPost: false,
            posts: [],
            showingPosts: [],
            tabIndex: null,
            ROOT_API: null,
            hasNews: 1,
            busy: false,
            returnLoad: "",
            showAlertBar: false,
            filteredList: [],
            pendingBill: 0,
            sortType: "DATEDESC",
            comments:[],
            nextCommentsUrl: null,
            siteName: "",
            loadingNextComments: false,
            userAvatar: null,
            categories: [],
        };
    },
    mixins: [sectionsMixins, apiMixins],
    methods: {
        updateActiveCategory(categoryId, categoryRoute) {
            document.querySelector(`a:has([data-id="${categoryId}"])`).click()

            this.posts = [];

            this.activeCategory = categoryId;
            this.activeCategoryRoute = categoryRoute;

            window.localStorage.setItem("activeCategory", categoryId);
            window.localStorage.setItem("activeCategoryRoute", categoryRoute);

            this.sortType = this.getSortType(categoryId);

            this.updateCategories(categoryId);

            this.loadPosts();
            
            this.activeCategory = categoryId;
		    this.showingPosts = this.filteredPosts(false);
        },
        checkWelcome() {
            let formData = new FormData();
            formData.append("welcome", 0);
            let token = this.$session.get("jwt");
            axios({
                method: "post",
                url: this.ROOT_API + "api/site/" + this.siteId + "/update/welcome",
                data: formData,
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
                .then((response) => {
                    if ((response.data.status = 1)) {
                        this.$session.set("welcome", 0);
                        this.getStart = false;
                    }
                })
                .catch((response) => {
                    this.getStart = false;
                });
        },
        checkCategoryActive() {
            if (this.activeCategory > 0) {
                // PEGA O INDEX DO ARRAY DE CATEGORIAS COM BASE NO ID DA CATEGORIA
                let newIndex = this.categories.findIndex(
                    (category) => category.id == this.activeCategory
                );

                // PEGA O OBJETO COM BASE NO INDEX RETORNADO
                const category = this.categories.find(
                    (category) => category.id == this.activeCategory
                );
                    
                // CASO NAO ENCONTRE NADA NO FIND INDEX O VALOR RETORNADO VEM COMO -1
                // SENDO NECESSARIO VALIDAR PARA DEFINIR UM VALOR PADRÃO PARA A NAVEGAÇÃO 
                // NO NOSSO CASO É O INDEX 1 - HOME
                if (newIndex == -1) {
                    newIndex = 1;
                }

                // ANTES DE REALMENTE DEFINIR QUAL TAB ESTÁ ATIVA, VERIFICA SE O INDEX RETORNADO É 1
                // CASO SEJA, O INDEX DA TAB É 1, CASO CONTRÁRIO É O INDEX RETORNADO + 2
                this.tabIndex = newIndex == 1 ? newIndex : newIndex + 2

                this.sortType = category && category.sortBy ? category.sortBy : "CHRONODESC";
            } else {
                this.tabIndex = 1;
            }
        },
        hideAlertMessage() {
            this.alertMessageData.message = "Algo de errado não está certo.";
            this.alertMessageData.show = false;
        },
        clearActiveCategory() {
            this.isBlog = false;

            window.localStorage.removeItem("activeCategory");
            window.localStorage.removeItem("activeCategoryRoute");

            this.activeCategoryRoute = null;
            this.activeCategory = null;
        },
        getSortType(categoryId) {
            const category = this.categories.find(
                (category) => category.id === categoryId
            );
            return category.sortBy;
        },
        handleHome() {            
            this.clearActiveCategory();

            this.loadPosts();
        },
        handleSearch() {
            this.clearActiveCategory();
        },
        async loadPosts() {
            // LIMPA VARIAVEIS PARA NÃO DAR PROBLEMA DE APARECER OS POSTS CARREGADOS DE OUTRA PAGINA
            this.posts = [];
            this.showingPosts = [];

            // ATIVA LOADING
            this.busy = true;
            this.hasNews = 0;

            // RECUPERANDO POSTS
            this.posts = await this.loadSitePosts(this.siteId, this.activeCategory);

            // FILTRANDO POSTS QUE FORAM RECUPERADOS COM BASE NO FILTRO ATIVO
            this.showingPosts = this.filteredPosts();

            // DESATIVA LOADING
            this.busy = false;
            this.hasNews = 1;

            // ATUALIZA O STORE COM OS FILTROS ATUALIZADOS
            this.$store.dispatch("dashboardModule/POPULATEPOSTCARDS", [
                this.showingPosts,
            ]);
        },
        toggleAlertMessage() {
            (this.alertMessageData.tlte = "Oops..."),
                (this.alertMessageData.message =
                    "Este item não pode ser excluído pois é o único item de destaque do seu site");
            this.alertMessageData.show = true;
        },
        handleScroll(event) {
            this.showAlertBar =
                event.target.scrollingElement.scrollTop > 440 &&
                this.$store.state.siteActive.contract.is_trial === 1;
        },
        async createPost(pageId = null) {
            if (!pageId) {
                const listPagesCategories = this.categories.filter(
                    (category) => category.listPages === 1
                );
    
                if (this.activeCategory === null) {
                    if (listPagesCategories.length === 1) {
                        this.activeCategory = listPagesCategories[0].id;
                    }
                }

                pageId = this.activeCategory;
            }

            const data = {
                id: pageId,
            };
            const haveListpage = this.categories.some(
                (category) => category.listPages === 1
            );
            if (haveListpage) {
                const url = `/site/${this.siteId}/post/new`;
                const newPostId = await this.requestApiData(url, "post", data);
                this.$session.set("postId", newPostId.postId);
                this.$router.push({
                    name: "PostEditor",
                    params: { postId: newPostId.postId },
                });
            } else {
                this.alertMessageData.title = "Oops...";
                this.alertMessageData.message =
                    "Você precisa de uma página de listagem antes de criar um novo post";
                this.alertMessageData.show = true;
            }
        },
        async populateComments() {
            if (this.nextCommentsUrl) {
                this.loadingNextComments = true;
                const url = this.nextCommentsUrl.replace("https://api.uli/api","")
                const responseApi = await this.requestApiData(url, "get");
                this.comments.push(...responseApi.data)
                this.loadingNextComments = false;
                this.nextCommentsUrl = responseApi.next;
                this.$store.dispatch("dashboardModule/setCommits", [this.comments]);
            } else {
                const url = `/site/${this.siteId}/comments`;
                const responseApi = await this.requestApiData( url , "get" );
                this.comments = responseApi.data;
                this.siteName = responseApi.site.site_name;
                this.nextCommentsUrl = responseApi.next;
                this.$store.dispatch("dashboardModule/setComments", [this.comments]);
            }
        },
        normalizeName(name) {
            return name ? name.replace(/<p>|<\/p>/g, "") : "";
        },
        checkCards(id) {
            return this.posts.some(
                (post) =>
                    post.category.find((category) => category.value === id) != null &&
                    post.deleted == 0
            );
        },
        updateCategories(categoryId) {
            const categoryActive = this.categories.findIndex(
                (category) => category.id == categoryId
            );
            this.categories[categoryActive].sortBy = this.sortType;
        },
        onChange(listPages, categoryId, externalLink, categoryRoute) {
            this.posts = [];
            this.isBlog = false;

            if (externalLink == "external_url") {
                this.clearActiveCategory();

                this.$session.set("pageId", categoryId);
                this.$router.push("/dashboard/link-management");
            }else if (externalLink == "store") {
                this.clearActiveCategory();

                this.$session.set("pageId", categoryId);
                this.$router.push("/dashboard/store-management");
            } else if (listPages == 0) {
                this.clearActiveCategory();

                // Redirect para Post Editor
                this.$session.set("postId", categoryId);
                this.$router.push({
                    name: "PostEditor",
                    params: { postId: categoryId },
                });
            } else {
                this.isBlog = true;
                this.activeCategory = categoryId;
                this.activeCategoryRoute = categoryRoute;

                window.localStorage.setItem("activeCategory", categoryId);
                window.localStorage.setItem("activeCategoryRoute", categoryRoute);

                this.sortType = this.getSortType(categoryId);

                this.updateCategories(categoryId);

                this.loadPosts();
            }

            this.activeCategory = categoryId;
		    this.showingPosts = this.filteredPosts(false);
        },
        updateSortType(sortType, categoryId) {
            this.sortType = sortType;

            this.updateOrder(categoryId);
        },
        async updateOrder(categoryId) {
            this.isLoading = true;
            const token = this.$session.get("jwt");
            const filteredPosts = this.showingPosts;

            this.updateCategories(categoryId);

            const data = {
                sortBy: this.sortType,
                items: filteredPosts,
            };

            try {
                const request = await axios({
                    method: "post",
                    url: `${this.ROOT_API}api/site/${this.siteId}/post/${categoryId}/sort`,
                    data: data,
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });

                if (request.status === 200) {
                    this.showingPosts = this.filteredPosts(true);
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
        filteredPosts(sort = true) {
            const sortingFunctions = {
                DATEASC: (post1, post2) => {
                    if (post1.created_time < post2.created_time) return -1;
                    if (post1.created_time > post2.created_time) return 1;

                    return parseInt(post1.postId) > parseInt(post2.postId) ? 1 : -1;
                },
                DATEDESC: (date1, date2) => {
                    if (date1.created_time > date2.created_time) return -1;
                    if (date1.created_time < date2.created_time) return 1;

                    return parseInt(date1.postId) < parseInt(date2.postId) ? 1 : -1;
                },
                CHRONOASC: (post1, post2) => {
                    if (
                        moment(post1.published_at, "YYYY-MM-DD").toDate() >
                        moment(post2.published_at, "YYYY-MM-DD").toDate()
                    )
                        return 1;
                    if (
                        moment(post1.published_at, "YYYY-MM-DD").toDate() <
                        moment(post2.published_at, "YYYY-MM-DD").toDate()
                    )
                        return -1;

                    return parseInt(post1.postId) > parseInt(post2.postId) ? 1 : -1;
                },
                CHRONODESC: (date1, date2) => {
                    if (
                        moment(date1.published_at, "YYYY-MM-DD HH:mm").toDate() <
                        moment(date2.published_at, "YYYY-MM-DD HH:mm").toDate()
                    )
                        return 1;
                    if (
                        moment(date1.published_at, "YYYY-MM-DD HH:mm").toDate() >
                        moment(date2.published_at, "YYYY-MM-DD HH:mm").toDate()
                    )
                        return -1;

                    return parseInt(date1.postId) < parseInt(date2.postId) ? 1 : -1;
                },
                ALPHABDESC: (post1, post2) => {
                    const innerPost1 = { ...post1 };
                    const innerPost2 = { ...post2 };
                    if (innerPost1.title)
                        innerPost1.title = this.normalizeTitlePosts(innerPost1.title);
                    if (innerPost2.title)
                        innerPost2.title = this.normalizeTitlePosts(innerPost2.title);
                    if (innerPost1.title > innerPost2.title || !innerPost2.title)
                        return -1;
                    if (innerPost1.title < innerPost2.title || !innerPost1.title)
                        return 1;
                    return 0;
                },
                ALPHABASC: (post1, post2) => {
                    const innerPost1 = { ...post1 };
                    const innerPost2 = { ...post2 };
                    if (innerPost1.title)
                        innerPost1.title = this.normalizeTitlePosts(innerPost1.title);
                    if (innerPost2.title)
                        innerPost2.title = this.normalizeTitlePosts(innerPost2.title);
                    if (innerPost1.title < innerPost2.title || !innerPost2.title)
                        return -1;
                    if (innerPost1.title > innerPost2.title || !innerPost1.title)
                        return 1;
                    return 0;
                },
                CUSTOM: (post1, post2) => {
                    const post1Position = post1.position;
                    const post2Position = post2.position;

                    if (post1Position === post2Position) {
                        return 0;
                    }
                    return post1Position > post2Position ? 1 : -1;
                },
            };

            if (sort) {
                return this.posts.sort(sortingFunctions[this.sortType]);
            }

            return this.posts;
        },
        normalizeTitlePosts(title) {
            return title.toLowerCase()
                .trim()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        },
    },
    computed: {
        checkTrial() {
            return this.$store.state.siteActive.contract.is_trial === 1;
        },
        checkCodes() {
            return (
                this.$store.state.user.codes &&
                this.$store.state.user.codes.length > 0
            );
        },
        checkImporteds() {
            return this.posts.filter((post) => post.is_imported == 1).length;
        },
        ...mapGetters("dashboardModule", ["getAllPages","getComments"]),
    },
    watch: {
        daysReport(){
            this.report = false;
            setTimeout(() => {
                this.report = true
            }, 10);
        },
        posts(newPosts, oldPosts) {
            if (!oldPosts.length) {
                this.showingPosts = [...newPosts];
            } else {
                this.showingPosts = this.filteredPosts(false);
            }
        },
    },
    beforeCreate() {
        if (!this.$session.exists()) {
            window.location.href = "https://" + window.location.hostname;
        }

        if (
            this.$session.get("wizard") == 0 &&
            !localStorage.getItem("wizardFinish")
        ) {
            this.$router.push("/wizard");
        }

        if (this.$session.has("postId")) {
            this.$session.remove("postId");
        }
    },
    created() {
        this.ROOT_API = process.env.ROOT_API;
        this.siteId = this.$session.get("siteId");

        this.populateCategories();
        this.populateComments();

        // this.$zendesk.show();

        this.clearActiveCategory();


        window.addEventListener("scroll", this.handleScroll);
    },
    beforeMount() {
        this.getStart = this.$session.get("welcome");

        this.clearActiveCategory();
        
        this.loadPosts();
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>

<style scoped>
.box{
    overflow-x: auto;
    overflow-y: hidden;
    margin-left: -25px;
}
.comment-card{
	box-sizing: border-box;
    background-clip: padding-box;
    border-width: 0px 0px 0px 25px;
    border-style: solid;
    border-color: transparent;
    border-image: initial;
}
.next-comments{
	height: 53px;
	margin-top: 51px;
	margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/DashboardHome.vue